export default "__VITE_ASSET__FT$ZnwKW__"